export const blackBoxPriceDetailsModalSize = '1024px';
